<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
<!--    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['ad.status']">
              <j-dict-select-tag  v-model="queryParam.status"  :type="'radio'" dictCode="ad_status"/>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

    </div>-->
    <!-- 查询区域-END -->





    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{this.language['common.insertButton']}}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
        </div>


      <a-table
        ref="table"
        size="middle"
        :scroll="{x:1200}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">


        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
<!--        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" @click="aa(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>-->


        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" height="25px" width="50px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            :title="language['ad.image']"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>




        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}}<a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{language['common.look']}}</a>
              </a-menu-item>
              <!--public关键字不可编辑，也不能删除-->
              <a-menu-item v-if="record.dsKey!='public'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <data-source-modal ref="modalForm" @ok="modalFormOk"></data-source-modal>
  </a-card>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DataSourceModal from './modules/DataSourceModal'
  import store from '@/store/'

  export default {
    name: 'SysBmAdList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      DataSourceModal
    },
    data () {
      return {
        description: '数据源管理页面',
        url: {
          list: "/sys/datasource/list",
          delete: "/sys/datasource/delete",
          deleteBatch: "/sys/datasource/deleteBatch"

        },
        applicationCode:'platform',
        dictOptions:{},
        superFieldList:[],
        applicationList:{},
        previewVisible: false,
        previewImage: '',
      }
    },
    created() {
      this.getApplicationList();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              //关键字
              title:this.language["ispforum.keyword"],
              width: 180,
              align:"center",
              dataIndex: 'dsKey'

            },
            {
              //状态
              title:this.language["datasource.type"],
              width: 180,
              align:"center",
              dataIndex: 'dataSourceType'

            },
            {
              //状态
              title:this.language["fd.status"],
              width: 180,
              align:"center",
              dataIndex: 'state',
              customRender:function (t,r,index) {
                  if(t==0){
                    return store.getters.language['gift.user.status.valid'];
                  }else{
                    return store.getters.language['gift.user.status.invalid'];
                  }
              }

            },
            {
              title:this.language['common.action'],
              dataIndex: 'action',
              align:"center",
              width:147,
              fixed: 'right',
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      }
    },
    methods: {
      initDictConfig(){
      },

      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
      getApplicationList(){
        httpAction("/sys/role/getSysBmApplication", "", "get").then((res) => {
          if (res.success) {
            this.applicationList = res.result;
          }
        })
      }
    }
  }
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>